// extracted by mini-css-extract-plugin
export default {"link":"link_link__3G00E","external":"link_external__2wfYn","active":"link_active__3B5hw"};